import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1 className="my-5">Payment Coming soooooooooN!....</h1>
        </div>
    );
};

export default Payment;